import React from 'react';
import StyleButton from '../styleButton';
var BlockStyleControl = function BlockStyleControl(_ref) {
  var control = _ref.control,
    editorState = _ref.editorState,
    onToggle = _ref.onToggle;
  var selection = editorState.getSelection();
  var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  return /*#__PURE__*/React.createElement(StyleButton, {
    key: control.label,
    active: control.style === blockType,
    label: control.label,
    onToggle: onToggle,
    style: control.style,
    icon: control.icon
  });
};
export default BlockStyleControl;